import styled from "styled-components";
import { BreakPoints, FontWeights } from "../../constants";
import { typographyMixin } from "../../typography";

export const StyledHeadToHeads = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 1rem 0 0 0;
  ${typographyMixin}
`;

export const StyledHeadToHead = styled.div<{ enableLinks: boolean }>`
  margin: 0.5rem 0.5rem 0 0;
  @media only screen and (max-width: ${BreakPoints.sm}) {
    margin: 0.5rem 0rem;
  }

  cursor: ${(props) => (props.enableLinks ? "pointer" : "default")};

  &:hover {
    background: ${(props) => props.enableLinks && "rgba(55, 56, 61, 0.2)"};
  }
`;

export const Logo = styled.img`
  object-fit: contain;
  max-width: 50px;
  max-height: 50px;
`;

export const StyledHead = styled.div`
  min-height: 50px;
  display: flex;
  justify-content: space-between;

  border-right: 3px solid;
  border-color: ${(props) => props.theme.secondaryColor};

  &:nth-child(even) {
    background-color: rgba(55, 56, 61, 0.05);
  }

  @media only screen and (max-width: ${BreakPoints.sm}) {
    min-height: 35px;
  }
  .score {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    padding-right: 1rem;
    font-weight: ${FontWeights.bold};
    text-align: center;
    flex-basis: 50px;

    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 14px;
      flex-basis: 30px;
    }
  }

  .date {
    font-size: 16px;
    padding: 0.25rem;
    text-transform: uppercase;
    writing-mode: vertical-rl;
    text-orientation: upright;
    background-color: ${(props) => props.theme.secondaryColor};
    color: ${(props) => props.theme.textOnSecondaryColor};
    text-align: center;

    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 8px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    text-align: center;
    flex-grow: 1;
    padding-left: 1rem;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 14px;
      justify-content: center;
      padding-left: 0rem;
    }
  }

  .image {
    padding: 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-basis: 64px;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      display: none;
    }
  }
`;
